import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import {
  competitionVideoPreviewTime,
  competitionVideoSrcWithPreviewTime,
  primeVideoElementFrame,
} from "../../../utils/competitionEventMedia";

/**
 * Promo on competition detail — competition banner until playback starts.
 */
export default function CompetitionPromoVideo({ src, poster, sx }) {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);
  const previewTime = competitionVideoPreviewTime();
  const hasPoster = Boolean(poster);

  useEffect(() => {
    setRevealed(false);
  }, [src, poster]);

  useEffect(() => {
    if (!src || hasPoster) return;
    const el = ref.current;
    if (!el) return;

    let cancelled = false;

    const run = async () => {
      const ok = await primeVideoElementFrame(el, previewTime);
      if (cancelled || ok) return;
      el.src = competitionVideoSrcWithPreviewTime(src, previewTime);
    };

    void run();

    return () => {
      cancelled = true;
    };
  }, [src, previewTime, hasPoster]);

  const handlePlaying = () => {
    setRevealed(true);
    const el = ref.current;
    if (el) el.muted = false;
  };

  return (
    <Box sx={{ position: "relative", bgcolor: "#000", lineHeight: 0 }}>
      {hasPoster && !revealed ? (
        <Box
          component="img"
          src={poster}
          alt=""
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />
      ) : null}
      <Box
        component="video"
        ref={ref}
        src={src}
        poster={poster || undefined}
        controls
        playsInline
        preload={hasPoster ? "none" : "auto"}
        onPlaying={handlePlaying}
        sx={{ width: "100%", display: "block", position: "relative", zIndex: 2, ...sx }}
      />
    </Box>
  );
}
